import { createSelector } from "@ngrx/store";
import { IProfessionalTransfersReportState } from "./professional-transfers-report.reducer";

const professionalTransfersReportStore = (state: any) => state.professionalTransfersReport as IProfessionalTransfersReportState;

export const selectProfessionalTransfersReport = createSelector(
    professionalTransfersReportStore,
    (state) => state.professional_transfers_report
);